import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _Entailment } from "../../../core/services/dataBean/EntityCatalog";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { SelectTypeProcees } from "../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { _SignAndApprovalPanel } from "../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../theme/Component/BasicButton";
import { EditorSignAndApprovalPanel } from "./EditorSignAndApprovalPanel";
import { AccountEditor } from "../../editor/AccountEditor";
import { SelectFunctionalArea } from "../../admin/configuracion/FunctionalArea/SelectFunctionalArea";
import { SelectorDocumentFactory } from "../bodegaDocumentos/SelectorDocumentFactory";
import { DocumentStorageEditor } from "../bodegaDocumentos/DocumentStorageEditor";

interface Props {
    IDSignAndApprovalPanel: number;
}

export const SimularfirmasFlujo = ({ IDSignAndApprovalPanel }: Props) => {

    const SimularfirmasFlujo = useDataBean(_SignAndApprovalPanel);
    const single = Singleton.getInstance();
    const [documentfactory, setDocumentfactory] = useState<any>(null);
    const [account, setAccount] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [verfirmas, setVerfirmas] = useState<any>({ name: 'Firmas', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        // getLista();
    }, [IDSignAndApprovalPanel])



    // documentfactory.IDDocument,documentfactory.Since, account

    const getLista = () => {
        // console.log(documentfactory)
        SimularfirmasFlujo.instance.getSigningDocumentFlowList(IDSignAndApprovalPanel, null, null, account).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        SimularfirmasFlujo.setBean({
            IDSignAndApprovalPanel: IDSignAndApprovalPanel,
            // RequiresSign: true,
            IDEmployee: single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        SimularfirmasFlujo.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDSignAndApprovalPanel', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Título de Firma', property: 'Title', visible: true },
        { title: 'Requerir Acción de Firma', property: 'RequiresSign', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Firmante', property: 'EntityName', visible: true },

    ]




    return (
        <BasicPage titulo="Simular Flujo de Firma">
            <div className="row">

                <div className="col-md-6">
                    <DocumentStorageEditor label="Documento" onChange={(e) => setDocumentfactory(e)} />
                </div>
                <div className="col-md-6">

                    <AccountEditor idAccount={null} label="Funcionario" onChange={(e) => { setAccount(e.IDAccount) }} />

                </div>

                <div className="col-md-4 mt-4">
                    <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={SimularfirmasFlujo.setBean}></BasicTable>



                </div>

            </div>
        </BasicPage>
    )
}